import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityType, TradingEntity } from 'api'
import { Field } from 'view/components/inputs'
import { SelectboxProps } from 'view/components/options'
import { createEntitySelectbox } from '../EntityOptions'
import { OrganisationMetaSelectorProps, organisationMetaTradingEntityIdsSelector } from 'selectors/organisationSelectors'
import { Locale, Translation } from 'locale'

export interface OrgMetaTradingEntitySelectboxProps
  extends OrganisationMetaSelectorProps,
    Omit<SelectboxProps<TradingEntity, string>, 'optionKeys' | 'value' | 'disabled'> {
  organisationId: string
  selectedTradingEntityId: string | null
  tradingEntityIds: string[]
}

const mapStateToProps = createStructuredSelector({
  tradingEntityIds: organisationMetaTradingEntityIdsSelector
})

const mapDispatchToProps = {}

const EntitySelectbox = createEntitySelectbox(EntityType.TRADING_ENTITY)
const OrgMetaTradingEntitySelectboxComponent: React.FunctionComponent<OrgMetaTradingEntitySelectboxProps> = props => {
  const { selectedTradingEntityId, tradingEntityIds, readOnly, ...rest } = props

  return (
    <EntitySelectbox
      optionKeys={tradingEntityIds}
      value={selectedTradingEntityId}
      canClear={true}
      nullItemText={Locale.translate(Translation.TC_ORGANISATION_META_ALL)}
      disabled={tradingEntityIds.length === 0}
      {...rest}
    />
  )
}

export const OrgMetaTradingEntitySelectbox = connect(mapStateToProps, mapDispatchToProps)(OrgMetaTradingEntitySelectboxComponent)

export const OrgMetaTradingEntitySelectboxField = Field(OrgMetaTradingEntitySelectbox)
